import React from "react";
import {TouchableOpacity, View, Text} from "react-native";
import {Color, globalFontStyle} from "../../../assets";
import FastImage from "../../../common/FastImage";
import {tick} from "../../../utils/images";

const RewardClaimBottomSheet = ({dataObj, closeBottomSheet}) => {
  return (
    <View style={{alignItems: "center", padding: 35, paddingBottom: 0}}>
      <FastImage
        style={{width: 50, height: 50, marginBottom: 15}}
        source={tick()}
      />
      <Text style={[globalFontStyle.appFontHeading, {color: Color.black}]}>
        {dataObj?.title}
      </Text>
      <Text style={[globalFontStyle.appFontSmallText, {marginTop: 6}]}>
        {dataObj?.info}
      </Text>

      <TouchableOpacity onPress={closeBottomSheet}>
        <Text
          style={[
            globalFontStyle.appFontSmallText,
            {color: Color.green, marginTop: 30},
          ]}>
          {dataObj?.footer}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default RewardClaimBottomSheet;
